import { render, staticRenderFns } from "./Overrider.vue?vue&type=template&id=2d3a0291"
import script from "./Overrider.vue?vue&type=script&lang=js"
export * from "./Overrider.vue?vue&type=script&lang=js"
import style0 from "./Overrider.vue?vue&type=style&index=0&id=2d3a0291&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports